import apiClient from './api';

/**
 * R8 try-on analytics: COUNTS only. The request body is a product id and an
 * event name -- never an image, a frame or anything about the person.
 * Best-effort: a failed count never bothers the shopper.
 */
const KEY = (id) => `zaynic-tryon-${id}`;

function send(productId, event) {
  return apiClient.post('/tryon/events', { product_id: productId, event }).catch(() => {});
}

export function noteTryOnOpened(productId) {
  try {
    sessionStorage.setItem(KEY(productId), '1');
  } catch {
    /* storage blocked: still count the open */
  }
  return send(productId, 'open');
}

/** Called after a successful add-to-cart; counts once per try-on session. */
export function noteTryOnAddToCart(productId) {
  let opened = false;
  try {
    opened = sessionStorage.getItem(KEY(productId)) === '1';
    if (opened) sessionStorage.setItem(KEY(productId), 'carted');
  } catch {
    opened = false;
  }
  return opened ? send(productId, 'add_to_cart') : Promise.resolve();
}
